import { withErrorBoundary } from 'app/components/error-boundary';
import type { NavigationScreen } from 'app/types/navigation';
import { View } from 'react-native';
import { BorrowerNextScreenBody } from './borrower-next-screen-body';
import { useBorrowerNextScreen } from './use-borrower-next-screen';

const BorrowerNextScreenComponent: NavigationScreen<'borrowerNext'> = ({ navigation }) => {
  const screenState = useBorrowerNextScreen(navigation);

  return (
    <View style={{ flex: 1 }}>
      <BorrowerNextScreenBody {...screenState} />
    </View>
  );
};

export const BorrowerNextScreen: NavigationScreen<'borrowerNext'> = withErrorBoundary(BorrowerNextScreenComponent);
